import React from 'react';
import './Corporate.css';

const Corporate = () => {
  return (
    <div className="corporate-container">
      <div className="corporate-content">
        <h1 className="corporate-title">CORPORATE CULTURE</h1>
        <div className="corporate-text">
          <p>
            Corporate culture stands as a foundational element influencing the triumph of any enterprise. Since its inception, the Rupasinghe Steels Management Board has meticulously crafted a distinctive and unparalleled <em>"Corporate Culture"</em> framework.
          </p>
          <p>
            <em>People</em> – the nucleus shaping our corporate culture.
          </p>
          <p>
            Rupasinghe Steels fosters a diverse and multinational community where each individual brings uniqueness and distinct personality. Yet, collectively, we share a unified objective: to elevate the business value of Rupasinghe Steels. Our corporate culture has evolved over time, aligning with the continual prosperity and enduring success of our organization.
          </p>
          <p>
            <strong>RESPONSIBILITY:</strong><br />
            Responsibility serves as a clear metric for assessing an individual's moral values. At Rupasinghe Steels, responsibility encompasses two dimensions:
          </p>
          <ul>
            <li>A willingness to shoulder responsibility, acknowledge mistakes, and rectify them.</li>
            <li>Responsibility towards work and self.</li>
          </ul>
          <p>
            <strong>CHANGE:</strong><br />
            The essence of "change" lies in perpetual improvement, a commitment to innovation that nurtures personal growth. Rupasinghe Steels actively cultivates a professional yet unrestrained work environment, empowering employees to unleash creativity, drive change, and enhance the quality of our work.
          </p>
          <p>
            <strong>FAIRNESS:</strong><br />
            Fairness is the cornerstone of effective management and leadership roles. At Rupasinghe Steels, our work environment vehemently rejects unfairness and ambiguity. We uphold the values of "Fairness and Integrity," placing high value on talented individuals.
          </p>
          <p>
            <strong>MATURITY:</strong><br />
            In the human dimension, a business's success is gauged by the maturity of its personnel over time. Rupasinghe Steels is dedicated to fostering the personal growth and maturity of its employees through quality work and the cultivation of human values. Consequently, our personnel are consistently encouraged to refine professional skills and interpersonal capabilities through effective communication and behavior, both within and beyond the company.
          </p>
          <p>
            <strong>EFFICIENCY:</strong><br />
            Efficiency is the ultimate goal, captured in a formula designed for practical implementation. This goal allows us to evaluate entire processes, making necessary adjustments or refinements. Every facet of Rupasinghe Steels' "corporate culture" is geared towards delivering effective value, cultivating positivity at every level—from individuals and departments to divisions and the entire company.
          </p>
          <p>
            "Corporate culture serves as the intangible asset of a business, contributing to the creation of its immense strength."
          </p>
          <p>
            Rupasinghe Steels will steadfastly pursue the future, guided by the principle of <em>"Employee Development - Business Prosperity."</em>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Corporate;
